// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YoutubeVideo_wrapper__ypxEh","player":"YoutubeVideo_player__PIL8E"};